<template>
	<PackageIcon v-if="PackageIcon" :class="mergedClass" />
	<span v-else-if="iconAvailable" class="inline-block" :class="mergedClass" aria-hidden="true" />
</template>

<script lang="ts" setup>
import { LazyIconLoader } from '@thermenresorts/icons/lazy';
import { twMerge as tw, type ClassNameValue } from 'tailwind-merge';
import { computed, shallowRef, useAttrs, watch } from 'vue';

const attrs = useAttrs();

const props = defineProps<{
  name?: string | null
}>();

const loader = new LazyIconLoader();

const PackageIcon = shallowRef<string | null>(null);

const iconAvailable = computed(() => loader.resolve(props.name) !== null);

watch(() => props.name, async (name) => {
  PackageIcon.value = null;

  const svg = await loader.loadSvg(name);

  if (name === props.name) {
    PackageIcon.value = svg;
  }
}, { immediate: true });

const mergedClass = computed(() => tw(
  ['size-4 flex-none', props.name],
  attrs.class as ClassNameValue,
));
</script>
